import { EnumResponse } from '@/api/services/common.dto'
import axios from 'axios'

class DiagnosisResponsibilityService {
    async getResponsibilities(): Promise<EnumResponse> {
        const response = await axios.get<EnumResponse>(`/diagnosis/responsibilities`)
        return response.data
    }
}

export const diagnosisResponsibilityService = new DiagnosisResponsibilityService()
